import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./globals.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { JupyterWorkspaceProvider } from "./contexts/JupyterWorkspaceContext";
import { BrowserRouter } from "react-router-dom";
import { ProjectLinkProvider } from "./contexts/ProjectLinkContext.tsx";
const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <QueryClientProvider client={queryClient}>
        <ProjectLinkProvider>
          <JupyterWorkspaceProvider>
            <App />
          </JupyterWorkspaceProvider>
        </ProjectLinkProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
